// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * smapi-ticketing-api
 * The SBB Swiss Mobility API - Ticketing is an interface that you can integrate into your own distribution system. Fare details are made available to you via this interface. There are two ways to use the service:  - Either integrate the SBB Swiss Mobility API as a full version, so that bookings are made directly via your distribution environment - Or use the Affiliate solution, with a link to the SBB webshop or SBB mobile  Before you request access to our API, please get in contact with SBB Digital Affiliates by sending an email stating your intentions and goal. Please note that the purpose of our API is to generate sales turnover through it. Offers only is not permitted due to the Look2Book Ratio. Please check out our GTC as well. On the right you can find the contact details and the links to the important websites.  IMPORTANT: The journey endpoints `Locations` and `Trips` will be deprecated by October 31, 2024 and are planned to be removed in December 2024. Please switch to the new endpoints `/v1/places`, `/v1/trips-collection` and `/v1/trips/{tripId}` of the new [SBB Swiss Mobility Journey API](https://developer-int.sbb.ch/apis/smapi-osdm-journey/information). 
 *
 * The version of the OpenAPI document: latest
 * Contact: digitalsales@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProductPrice,
  ProductPricesRequest,
  TripPrice,
  TripPricesRequest,
} from '../models/index';
import {
    ProductPriceFromJSON,
    ProductPriceToJSON,
    ProductPricesRequestFromJSON,
    ProductPricesRequestToJSON,
    TripPriceFromJSON,
    TripPriceToJSON,
    TripPricesRequestFromJSON,
    TripPricesRequestToJSON,
} from '../models/index';

export interface PostProductPricesRequest {
    xConversationId: string;
    xContractId: string;
    productPricesRequest: ProductPricesRequest;
    acceptLanguage?: PostProductPricesAcceptLanguageEnum;
    timeshift?: string;
}

export interface PostTripPricesRequest {
    xConversationId: string;
    xContractId: string;
    tripPricesRequest: TripPricesRequest;
    acceptLanguage?: PostTripPricesAcceptLanguageEnum;
    timeshift?: string;
}

/**
 * 
 */
export class PriceApi extends runtime.BaseAPI {

    /**
     * Calculates the cheapest prices for the given product and given parameters
     */
    async postProductPricesRaw(requestParameters: PostProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductPrice>>> {
        if (requestParameters['xConversationId'] == null) {
            throw new runtime.RequiredError(
                'xConversationId',
                'Required parameter "xConversationId" was null or undefined when calling postProductPrices().'
            );
        }

        if (requestParameters['xContractId'] == null) {
            throw new runtime.RequiredError(
                'xContractId',
                'Required parameter "xContractId" was null or undefined when calling postProductPrices().'
            );
        }

        if (requestParameters['productPricesRequest'] == null) {
            throw new runtime.RequiredError(
                'productPricesRequest',
                'Required parameter "productPricesRequest" was null or undefined when calling postProductPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['xConversationId'] != null) {
            headerParameters['x-conversation-id'] = String(requestParameters['xConversationId']);
        }

        if (requestParameters['xContractId'] != null) {
            headerParameters['x-contract-id'] = String(requestParameters['xContractId']);
        }

        if (requestParameters['timeshift'] != null) {
            headerParameters['timeshift'] = String(requestParameters['timeshift']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2-azure-ad", ["api://36edceb9-f533-4201-b386-77b52afb4ca7/.default"]);
        }

        const response = await this.request({
            path: `/api/v2/product-prices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPricesRequestToJSON(requestParameters['productPricesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductPriceFromJSON));
    }

    /**
     * Calculates the cheapest prices for the given product and given parameters
     */
    async postProductPrices(requestParameters: PostProductPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductPrice>> {
        const response = await this.postProductPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculates the cheapest trip prices for the given parameters. This can be the regular or the saver fare if such is available. If you are subscribed to our affiliation programm you have to include your ID as an URL parameter, for further information please contact digitalsales@sbb.ch.  Detailed Information about fares and conditions you can find here: [fare-conditions-for-your-journey](https://www.sbb.ch/en/help-and-contact/customer-service/fare-conditions-for-your-journey.html)
     */
    async postTripPricesRaw(requestParameters: PostTripPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TripPrice>>> {
        if (requestParameters['xConversationId'] == null) {
            throw new runtime.RequiredError(
                'xConversationId',
                'Required parameter "xConversationId" was null or undefined when calling postTripPrices().'
            );
        }

        if (requestParameters['xContractId'] == null) {
            throw new runtime.RequiredError(
                'xContractId',
                'Required parameter "xContractId" was null or undefined when calling postTripPrices().'
            );
        }

        if (requestParameters['tripPricesRequest'] == null) {
            throw new runtime.RequiredError(
                'tripPricesRequest',
                'Required parameter "tripPricesRequest" was null or undefined when calling postTripPrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (requestParameters['xConversationId'] != null) {
            headerParameters['x-conversation-id'] = String(requestParameters['xConversationId']);
        }

        if (requestParameters['xContractId'] != null) {
            headerParameters['x-contract-id'] = String(requestParameters['xContractId']);
        }

        if (requestParameters['timeshift'] != null) {
            headerParameters['timeshift'] = String(requestParameters['timeshift']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2-azure-ad", ["api://36edceb9-f533-4201-b386-77b52afb4ca7/.default"]);
        }

        const response = await this.request({
            path: `/api/v2/prices`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TripPricesRequestToJSON(requestParameters['tripPricesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TripPriceFromJSON));
    }

    /**
     * Calculates the cheapest trip prices for the given parameters. This can be the regular or the saver fare if such is available. If you are subscribed to our affiliation programm you have to include your ID as an URL parameter, for further information please contact digitalsales@sbb.ch.  Detailed Information about fares and conditions you can find here: [fare-conditions-for-your-journey](https://www.sbb.ch/en/help-and-contact/customer-service/fare-conditions-for-your-journey.html)
     */
    async postTripPrices(requestParameters: PostTripPricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TripPrice>> {
        const response = await this.postTripPricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PostProductPricesAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type PostProductPricesAcceptLanguageEnum = typeof PostProductPricesAcceptLanguageEnum[keyof typeof PostProductPricesAcceptLanguageEnum];
/**
 * @export
 */
export const PostTripPricesAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type PostTripPricesAcceptLanguageEnum = typeof PostTripPricesAcceptLanguageEnum[keyof typeof PostTripPricesAcceptLanguageEnum];
